import React, { useEffect, useState } from "react";
import { getAllProperties } from "../../firebase/queries";
import HeadingComponent from "../../components/HeadingComponent";
import { useDispatch, useSelector } from "react-redux";
import { addProperties } from "./store/propertiesSlice";
import CustomTable from "../../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Space, Select, message } from "antd";
import { SettingOutlined, UsergroupDeleteOutlined } from "@ant-design/icons";
import DeleteModal from "../../components/DeleteModal";
import { getPropertyMembers } from "../Members/APIs/firebaseMemberSettingApi";
import {
  deleteProperty,
  deletePropertyFromUsers,
  getUsersByPropertyIds,
  updateProperty,
} from "./APIs/firebasePropertyApi";
import { parseFirebaseDateTime } from "../../utils/helper";

const Properties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterProperty, setFilterProperty] = useState("all");
  const [filteredProperties, setFilteredProperties] = useState([]);
  const user = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRemoveProperty = async (propertyId) => {
    setLoading(true);
    let assigned_property_ids = [...user.assigned_property_ids] || [];
    assigned_property_ids = assigned_property_ids.filter(
      (row) => row !== propertyId
    );

    let propertyMembers = await getPropertyMembers(propertyId);
    const propertyMembersIds = propertyMembers?.map((item) => item.id);

    let usersAssignedWithPropertyId = await getUsersByPropertyIds(
      propertyMembersIds
    );

    await deletePropertyFromUsers(usersAssignedWithPropertyId, propertyId);
    await deleteProperty({
      propertyId,
      assigned_property_ids,
      userId: user.id,
    }).finally(() => {
      setLoading(false);
    });
    const filtered = properties.filter(
      (property) => property.id !== propertyId
    );
    setProperties(filtered);
    message.success("Property deleted");
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      columnSearch: true,
    },

    {
      title: "Country",
      dataIndex: "country",
      columnSearch: true,
    },
    {
      title: "URL",
      dataIndex: "url",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, _record) => {
        const status = _record?.status || "active";
        const onChangeStatus = async (property_id, value) => {
          try {
            setLoading(true);
            let data = {
              id: property_id,
              status: value,
            };
            let updated_property_id = await updateProperty(data);
            const updatedProperties = properties.map((property) =>
              property.id === updated_property_id
                ? { ...property, status: value }
                : property
            );
            setProperties(updatedProperties);
            setFilteredProperties(updatedProperties);
            message.success("Status updated successfully");
          } catch (error) {
            console.log("error", error);
            message.error("Failed to update status");
          } finally {
            setLoading(false);
          }
        };
        return (
          <Select
            onChange={(value) => onChangeStatus(_record?.id, value)}
            style={{ width: 90 }}
            size="small"
            value={status}
            options={[
              { label: "Active", value: "active" },
              { label: "Archived", value: "archived" },
            ]}
          />
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
    },

    {
      title: "Action",
      key: "action",
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <>
            <SettingOutlined
              className="icons_style"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/widget-settings/${record?.id}`);
              }}
            />
            <UsergroupDeleteOutlined
              className="icons_style"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/members/${record?.id}`);
              }}
            />
            <DeleteModal
              handleDelete={() => handleRemoveProperty(record?.id)}
              title="Are you sure you want to delete this Property?"
            />
          </>
        </Space>
      ),
    },
  ];

  const getProperties = async () => {
    try {
      setLoading(true);
      let response = await getAllProperties();
      let updatedResponse = response?.map((item) => {
        return {
          ...item,
          createdAt: parseFirebaseDateTime(item?.createdAt),
        };
      });

      const propertyIds = response?.map((item) => {
        return {
          id: item?.id,
          name: item?.name,
        };
      });

      setProperties(updatedResponse);
      setFilteredProperties(updatedResponse);
      dispatch(addProperties(propertyIds));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getProperties();
  }, []);

  const handleChangeStatus = (value) => {
    setFilterProperty(value);
    switch (value) {
      case "all":
        setFilteredProperties(properties);
        break;
      case "active":
        setFilteredProperties(
          properties.filter((item) => item.status !== "archived")
        );
        break;
      case "archived":
        setFilteredProperties(
          properties.filter((item) => item.status === "archived")
        );
        break;
      default:
        setFilteredProperties(properties);
    }
  };

  return (
    <>
      <div className="flex_start">
        <HeadingComponent text="Properties" />
        <Select
          value={filterProperty}
          style={{
            width: 120,
            marginLeft: 10,
          }}
          onChange={handleChangeStatus}
          options={[
            {
              value: "all",
              label: "All",
            },
            {
              value: "active",
              label: "Active",
            },
            {
              value: "archived",
              label: "Archived",
            },
          ]}
        />
      </div>
      <br />

      <CustomTable
        dataSource={filteredProperties}
        columns={columns}
        loading={loading}
      />
    </>
  );
};

export default Properties;
